/* global $ */
/* eslint no-unused-vars: 0 */

const $html = $('html');
const $moblieNavOverlay = $.$body.find('.mobile-nav-overlay');
const $menuOverlayControls = $.$body.find('.js-mobile-menu-control');
const $openText = $.$body.find('.hamburger-control__open-label');
const $closeText = $.$body.find('.hamburger-control__close-label');
let lastScrollPosition = 0;
let timeOutTimer = null;

const openMenu = ($menu) => (e) => {
	console.log('opening menu', $menu, e.currentTarget);
	clearTimeout(timeOutTimer);
	e.preventDefault();
	$menuOverlayControls.addClass('is-active');
	$openText.hide().attr('aria-hidden', false).prop('hidden', false);
	$closeText.show().attr('aria-hidden', true).prop('hidden', true);
	lastScrollPosition = $('html, body').scrollTop();
	$menu.addClass('menu--pre-open temp-high-z').prop('hidden', false);
	timeOutTimer = setTimeout(() => {
		$menu.addClass('menu--open');
		$html.addClass('overlay-active mobile-menu-active');
		$menu.find('.mobile-overlay__inner').scrollTop(0);
		$menu.attr('aria-hidden', false);
	}, 2);
};

const closeMenu = ($menu, cancelEvent) => (e) => {
	console.log('closing menu');
	clearTimeout(timeOutTimer);
	$menuOverlayControls.removeClass('is-active');
	$html.removeClass('overlay-active mobile-menu-active');
	$menu.removeClass('menu--open');
	$openText.show().attr('aria-hidden', true).prop('hidden', true);
	$closeText.hide().attr('aria-hidden', false).prop('hidden', false);
	if (cancelEvent && e) {
		e.preventDefault();
		e.stopPropagation();
	}
	$menu.attr('aria-hidden', true).prop('hidden', true);
	window.scrollTo(lastScrollPosition, 0);
	$('html, body').animate({ scrollTop: lastScrollPosition }, 50);
	timeOutTimer = setTimeout(() => {
		$menu.removeClass('temp-high-z menu--pre-open');
	}, 200);
};

$.$body
	.on(
		'click',
		'.js-open-main-menu:not(.is-active)',
		openMenu($moblieNavOverlay)
	)
	.on(
		'click',
		'.js-close-main-menu, .js-open-main-menu.is-active',
		closeMenu($moblieNavOverlay)
	);

// close on ESC
document.addEventListener(
	'keyup',
	(ev) => ev.keyCode === 27 && closeMenu($moblieNavOverlay)()
);

// control the secondary mobile menu buttons at bottom of screen - show/hide on scroll
const secondaryNav = document.querySelector('.footer-sticky-btn');
let prevScrollpos = $.$body.scrollTop();
$.$body.on('scroll', (e) => {
	const currentScrollPos = $.$body.scrollTop();
	if (prevScrollpos > currentScrollPos) {
		secondaryNav.style.transform = 'translate3d(0,0,0)';
	} else {
		secondaryNav.style.transform = 'translate3d(0,110%,0)';
	}
	prevScrollpos = currentScrollPos;
});
